import { submitSchoolWaitlist } from '../../../services/SchoolWaitlistService.js';

export default {
    async sendSchoolWaitlistEntry(context, payload) {
        const entryData = {
            schoolName: payload.schoolName,
            contactName: payload.contactName,
            email: payload.email,
            phone: payload.phone || null,
            city: payload.city,
            country: payload.country,
            websiteOrInstagram: payload.websiteOrInstagram || null,
            danceStyles: payload.danceStyles || [],
            approxStudents: payload.approxStudents || null,
            message: payload.message || null,
            // Present when claiming an existing directory listing.
            schoolId: payload.schoolId || undefined,
        };

        const response = await submitSchoolWaitlist(entryData);
        context.commit('setLastWaitlistEntry', entryData);
        return response;
    },

    clearLastWaitlistEntry(context) {
        context.commit('setLastWaitlistEntry', null);
    },
};
